<template>
  <tr role="row">
    <td>
      {{ rowTitle
      }}<button
        v-if="isEditable && rowIndex < dataLength"
        v-access:[permissions]="{
          access: accessManager().ALL,
          code: accessConstante.STUDEA_MANAGER_REGISTRATION_ESTIMATE_PRICE,
        }"
        v-tooltip="{ title: $t('registration.quote.edit_cost') }"
        class="btn btn-icon row__icon ms-2"
        @click="editCost(rowIndex)"
      >
        <FontAwesomeIcon icon="fa-light fa-pen-to-square" />
      </button>
    </td>
    <RegistrationCompensationTableCellComponent
      v-for="(item, index) in row"
      :key="index"
      :index="index"
      :cell="item"
      :active="isActiveRow()"
    />
  </tr>
</template>

<script>
import RegistrationCompensationTableCellComponent from "@/components/registration/quote/table/RegistrationCompensationTableCellComponent.vue";
import { accessManager } from "@/services/security/access-manager";
import { accessConstante } from "@/constantes/access";

export default {
  name: "RegistrationCompensationTableRowComponent",
  components: { RegistrationCompensationTableCellComponent },
  props: {
    row: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: true,
      default: true,
    },
    dataLength: {
      type: Number,
      required: true,
    },
  },
  computed: {
    accessConstante() {
      return accessConstante;
    },

    rowTitle() {
      return this.rowIndex < this.dataLength
        ? this.$t("year") + " " + (Number(this.rowIndex) + 1)
        : this.$t("global.total");
    },
  },
  emitsd: ["editCost"],
  methods: {
    accessManager() {
      return accessManager;
    },
    isActiveRow() {
      return !!(
        (this.row?.remaining_charge?.initial &&
          Object.keys(this.row?.remaining_charge?.initial).length &&
          this.row?.remaining_charge?.final &&
          Object.keys(this.row?.remaining_charge?.final).length) ||
        this.row.total
      );
    },

    editCost() {
      this.$emit("editCost", Number(this.rowIndex) + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  &__icon {
    svg {
      width: 12px;
      height: 12px;
    }
  }
}

.btn-icon {
  svg {
    width: 12px;
    height: 12px;
  }
}
</style>
